export const dataToEntity = (data) => ({
  ...data.balance.merchantPnl.pnl.currencyMap,
})
